export default __webpack_public_path__ + "nokia.b3147ea4.png";